import styled from 'styled-components';

const DetailDescriptionUpgradablePlanContainer = styled.div<React.CSSProperties>``;

export default DetailDescriptionUpgradablePlanContainer;
